// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ModifyPositionMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_MODIFY_POSITION, fieldSet);
    }
    setPositionId(positionId) {
        this.setFieldValue(FieldsFactory.FIELD_POSITION_ID, positionId);
    }
    setProductType(productType) {
        this.setFieldValue(FieldsFactory.FIELD_PRODUCT_TYPE, productType);
    }
    setQuantity(amount) {
        this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
    }
}
